import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { isWarehouseTutorialActive } from "../joyrideStepHelpers";

interface StepScreenshotModalProps {
    show: boolean;
    onClose: () => void;
    step: number;
    screenshots: { step: number; src: string }[];
    dialogClassName?: string;
    centeredModal?: boolean;
    dataTour: string;
}

const StepScreenshotModal: React.FC<StepScreenshotModalProps> = ({
    show,
    onClose,
    step,
    screenshots,
    dialogClassName,
    centeredModal,
    dataTour,
}) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const currentScreen = screenshots.find((s) => String(s.step) === String(step));
    const tutorialActive = isWarehouseTutorialActive();

    useEffect(() => {
        if (contentRef.current && dataTour) {
            contentRef.current.setAttribute("data-tour", dataTour);
        }
    }, [dataTour, show]);

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered={centeredModal}
            size="xl"
            backdrop="static"
            keyboard={false}
            dialogClassName={`tutorial-middle-y-indent ${dialogClassName ? dialogClassName : ""}`}
            onEntered={() => {
                tutorialActive && requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
            }}
        >
            <div ref={contentRef}>
                <Modal.Body className="text-center">
                    {currentScreen && (
                        <img
                            key={currentScreen.step}
                            src={currentScreen.src}
                            alt="screenshot"
                            className="w-100 object-fit-contain"
                        />
                    )}
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default StepScreenshotModal;
